import React, { useId } from 'react';
import { IconCreditCard } from '@tabler/icons-react';
import './styles.scss';

// The Visa wordmark (simple-icons), cropped to its own height.
const VISA = 'M9.112 8.262L5.97 15.758H3.92L2.374 9.775c-.094-.368-.175-.503-.461-.658C1.447 8.864.677 8.627 0 8.479l.046-.217h3.3a.904.904 0 01.894.764l.817 4.338 2.018-5.102zm8.033 5.049c.008-1.979-2.736-2.088-2.717-2.972.006-.269.262-.555.822-.628a3.66 3.66 0 011.913.336l.34-1.59a5.207 5.207 0 00-1.814-.333c-1.917 0-3.266 1.02-3.278 2.479-.012 1.079.963 1.68 1.698 2.04.756.367 1.01.603 1.006.931-.005.504-.602.725-1.16.734-.975.015-1.54-.263-1.992-.473l-.351 1.642c.453.208 1.289.39 2.156.398 2.037 0 3.37-1.006 3.377-2.564m5.061 2.447H24l-1.565-7.496h-1.656a.883.883 0 00-.826.55l-2.909 6.946h2.036l.405-1.12h2.488zm-2.163-2.656l1.02-2.815.588 2.815zm-8.16-4.84l-1.603 7.496H8.34l1.605-7.496z';

function Mastercard() {
  const clip = useId();
  return <svg viewBox="0 0 30 18" aria-hidden="true">
    <defs><clipPath id={clip}><circle cx="11.5" cy="9" r="7" /></clipPath></defs>
    <circle cx="11.5" cy="9" r="7" fill="#eb001b" />
    <circle cx="18.5" cy="9" r="7" fill="#f79e1b" />
    <circle cx="18.5" cy="9" r="7" fill="#ff5f00" clipPath={`url(#${clip})`} />
  </svg>;
}

const LOGOS = {
  visa: () => <svg viewBox="0 7.9 24 8.2" aria-hidden="true"><path d={VISA} fill="#1434cb" /></svg>,
  mastercard: Mastercard,
  amex: () => <svg viewBox="0 0 34 22" aria-hidden="true"><rect width="34" height="22" fill="#006fcf" /><text x="17" y="14.6" textAnchor="middle" fill="#fff" fontSize="9" fontWeight="700" fontFamily="Arial, sans-serif">AMEX</text></svg>,
};

// The card's network as a small chip, the way checkouts show the card on file.
// Unknown networks fall back to a generic card glyph.
export default function CardBrand({ brand }) {
  const Logo = LOGOS[brand];
  return <i className={`studio-card-brand ${Logo ? `is-${brand}` : 'is-generic'}`} aria-hidden="true">{Logo ? <Logo /> : <IconCreditCard />}</i>;
}
